import React, {Component} from 'react'
import Flickity from 'flickity'
import {findDOMNode} from 'react-dom'

export default class extends Component {


  constructor(props){
    super(props)
    this.setup = this.setup.bind(this)
    this.updateSelected = this.updateSelected.bind(this)
  }

  shouldComponentUpdate(nextProps){
    return nextProps.children !== this.props.children
  }

  componentWillReceiveProps(newProps){
    if(this.props.selected != newProps.selected){
      this.flkty.select(newProps.selected)
    }
  }


  componentDidMount() {
    setTimeout(this.setup, 0)
  }

  setup(){
    this.flkty = window.flkty = new Flickity( findDOMNode(this), {
      cellSelector: '.cell',
      prevNextButtons: false,
      pageDots: false,
      resize: true,
      setGallerySize: false,
      ...this.props.options
    })
    this.flkty.on( 'select', this.updateSelected)
  }

  updateSelected(){
    if(typeof this.props.onSelect === 'function'){
      this.props.onSelect (this.flkty.selectedIndex)
    }
  }

  componentWillUnmount () {
    if (this.flkty) {
      this.flkty.off('select', this.updateSelected)
      this.flkty.destroy()
    }
  }

  render() {
    const {children, options, ...rest} = this.props
    return <div {...rest}>{children}</div>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Flickity.js
 **/